export const PAYROLLCOMPONENT_LOADING = "PAYROLLCOMPONENT_LOADING";
export const PAYROLLCOMPONENT_RESET = "PAYROLLCOMPONENT_RESET";
export const GET_PAYROLLCOMPONENT = "GET_PAYROLLCOMPONENT";
export const GET_PAYROLLCOMPONENT_SUCCESS = "GET_PAYROLLCOMPONENT_SUCCESS";
export const GET_PAYROLLCOMPONENT_FAIL = "GET_PAYROLLCOMPONENT_FAIL";
export const DELETE_PAYROLLCOMPONENT = "DELETE_PAYROLLCOMPONENT"
export const DELETE_PAYROLLCOMPONENT_SUCCESS = "DELETE_PAYROLLCOMPONENT_SUCCESS"
export const DELETE_PAYROLLCOMPONENT_FAIL = "DELETE_PAYROLLCOMPONENT_FAIL"
export const UPDATE_PAYROLLCOMPONENT = "UPDATE_PAYROLLCOMPONENT"
export const UPDATE_PAYROLLCOMPONENT_SUCCESS = "UPDATE_PAYROLLCOMPONENT_SUCCESS"
export const UPDATE_PAYROLLCOMPONENT_FAIL = "UPDATE_PAYROLLCOMPONENT_FAIL"
export const ADD_NEW_PAYROLLCOMPONENT = "ADD_NEW_PAYROLLCOMPONENT"
export const ADD_PAYROLLCOMPONENT_SUCCESS = "ADD_PAYROLLCOMPONENT_SUCCESS"
export const ADD_PAYROLLCOMPONENT_FAIL = "ADD_PAYROLLCOMPONENT_FAIL"